import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "\n      alert alert-warning\n      d-flex\n      align-items-center\n      justify-content-between\n    ",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VDButton = _resolveComponent("VDButton")!

  return (_ctx.failed)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("span", null, _toDisplayString(_ctx.$translate("TextResources_MfaSettingsUnavailable")), 1),
        _createVNode(_component_VDButton, {
          isLoading: _ctx.status === 'loading',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadSettings(true)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$translate("TextResources_RetryMfaSettings")), 1)
          ]),
          _: 1
        }, 8, ["isLoading"])
      ]))
    : _createCommentVNode("", true)
}